import { Expose, plainToClass, Transform } from 'class-transformer';
import RatesCompsetMainModel from '@/modules/cluster/models/rates-compset-main.model';
import ClusterHotelsModel from '@/modules/cluster/models/cluster.model';

export default class ClusterHotelsRatesModel extends ClusterHotelsModel {
    @Expose()
    @Transform((_, plain) => plainToClass(RatesCompsetMainModel, <RatesCompsetMainModel>plain.main_compset, { excludeExtraneousValues: true }))
    compsetMain: RatesCompsetMainModel | null = null;
}
